const env = process.env.REACT_APP_ENV || 'development';

const configs = {
  development: {
    api: 'http://localhost:8080/api/registration',
    xero_auth: 'http://localhost:8080/api/xero',
    myob_auth: 'http://localhost:8080/api/myob',
    myob_api: 'http://localhost:8080/api/myob/signup',
    captcha_key: '6Lfc0bwUAAAAABlKe5FaYK3Re1q9QmyajILc-crU',
    login_link: 'http://app.ezycollectuat.io/Ezycollect',
  },
  uat: {
    api: 'https://registration-app.ezycollectuat.io/api/registration',
    xero_auth: 'https://registration-app.ezycollectuat.io/api/xero',
    myob_auth: 'https://registration-app.ezycollectuat.io/api/myob',
    myob_api: 'https://registration-app.ezycollectuat.io/api/myob/signup',
    captcha_key: '6Lfc0bwUAAAAABlKe5FaYK3Re1q9QmyajILc-crU',
    login_link: 'http://app.ezycollectuat.io/Ezycollect',
  },
  production: {
    api: 'https://registration-app.ezycollect.io/api/registration',
    xero_auth: 'https://registration-app.ezycollect.io/api/xero',
    myob_auth: 'https://registration-app.ezycollect.io/api/myob',
    myob_api: 'https://registration-app.ezycollect.io/api/myob/signup',
    captcha_key: '6Lfc0bwUAAAAABlKe5FaYK3Re1q9QmyajILc-crU',
    login_link: 'https://app.ezycollect.io/Ezycollect/',
  },
}[env];

export default configs;
